import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useAppSelector } from 'utils/redux/useAppSelector';
import { agentHasRole } from './agentHasRole';
/**
 * Renders the children if the provided app user role matches current agent
 * role.
 */
export function IfAgentHasRole({ role, children }) {
    const { hasAccess } = useAppSelector((state) => ({
        hasAccess: agentHasRole(state.settings.profile.profile, role),
    }));
    return hasAccess ? _jsx(_Fragment, { children: children }) : null;
}
